import("./bootstrap").then(({ mount }) => {
    const localRoot = document.getElementById("plg-crm-drive");

    mount({
        mountPoint: localRoot!,
        routingStrategy: "browser"
    });
});

export { };
